import { render, staticRenderFns } from "./JetFormEditorRow.vue?vue&type=template&id=88f68ddc&"
import script from "./JetFormEditorRow.vue?vue&type=script&lang=js&"
export * from "./JetFormEditorRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports